import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/app/[locale]/(web)/earn/_page/index.tsx");
